import { ConfigProvider } from 'antd';
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import {
    DEFAULT_THEME,
    THEME,
    applyPrimaryColor,
    getStoredPrimaryColor,
    resetPrimaryColor,
} from './tokens';

const ThemeContext = createContext({
    primary: DEFAULT_THEME.primary,
    setPrimary: () => {},
    resetPrimary: () => {},
});

export function ThemeProvider({ children }) {
    const [primary, setPrimaryState] = useState(() => getStoredPrimaryColor() || THEME.primary);

    const setPrimary = useCallback((hex) => {
        const next = applyPrimaryColor(hex, { persist: true });
        setPrimaryState(next);
    }, []);

    const resetPrimary = useCallback(() => {
        const next = resetPrimaryColor({ persist: true });
        setPrimaryState(next);
    }, []);

    const value = useMemo(
        () => ({
            primary,
            setPrimary,
            resetPrimary,
        }),
        [primary, setPrimary, resetPrimary]
    );

    return (
        <ThemeContext.Provider value={value}>
            <ConfigProvider
                theme={{
                    token: {
                        colorPrimary: primary,
                    },
                }}
            >
                {children}
            </ConfigProvider>
        </ThemeContext.Provider>
    );
}

export function useAppTheme() {
    return useContext(ThemeContext);
}

export default ThemeProvider;
